require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-purposefulprojects.json") })
        }
      }, "path---es-articles-purposefulprojects");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-purposefulprojects!./.cache/json/es-articles-purposefulprojects.json
// module id = 2185
// module chunks = 231608221292675